import { setCookie, getCookie } from './cookies';

const $promoBanner = jQuery( '.promo-banner' );

if( $promoBanner.length ) {
	const cookieName = 'rightworks_promo';
	const cookie = getCookie( cookieName );

	$promoBanner.each( function() {
		let promoBannerID = jQuery(this).attr( 'data-promo-id' );

		if( cookie && cookie.indexOf( promoBannerID ) > 0 ) {
			jQuery(this).hide(); // Hide alert if its ID exists in cookie.
		}
	} );

	jQuery( document ).on( 'click', '.js-banner-close', function( e ) {
		e.preventDefault();
		const $promoBanner = jQuery( this ).parents( '.promo-banner' );
		let promoBannerID = $promoBanner.attr( 'data-promo-id' );
		$promoBanner.hide();

		setCookie( cookieName, cookie + promoBannerID ); // Append id to current cookie in case of multiple alerts active.
	} );
}